"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.starts-with");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _gradeInfo = require("@/api/basic/gradeInfo");
var _memberManagement = require("@/api/member/memberManagement");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MemberForm',
  props: {
    // 操作类型：add-新增，edit-编辑
    type: {
      type: String,
      default: 'add'
    },
    // 会员数据，编辑时传入
    memberData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      formData: {
        // userId: null,  // 使用userId而不id，匹配后端字段
        userName: '',
        // 用户名
        email: '',
        // 邮箱
        alias: '',
        // 昵称
        mobilePhone: '',
        // 手机号
        userpic: '',
        // 头像
        userRank: null,
        // 会员等级ID
        sex: 0,
        // 性别：0-保密，1-男，2-女
        registerType: 0,
        // 注册方式：0-系统注册，1-点餐，2-社交，3-支付宝
        isTest: false,
        // 是否测试用户
        isLogin: true,
        // 是否允许登录
        birthday: '',
        // 出生日期
        // 默认值字段（后端必填字段）
        parentId: 0,
        // 推荐人 ID
        isValidated: 0,
        // 验证状态
        userType: 1,
        // 用户类型：1-H5
        channelCode: 'web',
        // 渠道代码
        sort: 0,
        // 排序
        isBlack: 0,
        // 是否黑名单
        adminId: 0,
        // 管理员ID
        birthdayFlag: 0,
        // 生日修改标识
        editFlag: false,
        // 自定义资料标识
        isSubscriber: false,
        // 是否订阅
        isMyminiapp: false,
        // 是否添加小程序
        isWecom: false,
        // 是否添加企微
        isPsg: 0 // 是否评审官
      },
      rules: {
        userName: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }, {
          min: 2,
          max: 60,
          message: '长度在2到60个字符',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: '请输入邮件地址',
          trigger: 'blur'
        }, {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }],
        alias: [{
          required: true,
          message: '请输入昵称',
          trigger: 'blur'
        }, {
          max: 60,
          message: '昵称长度不能超过60个字符',
          trigger: 'blur'
        }],
        mobilePhone: [{
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        userReallyName: [{
          max: 60,
          message: '真实姓名长度不能超过60个字符',
          trigger: 'blur'
        }]
      },
      // 头像预览URL
      avatarPreviewUrl: null,
      // 等级相关数据
      vipGrades: [],
      gradeLoading: false,
      // 头像上传相关
      avatarUploading: false,
      // 图片资源前缀
      imagePrefix: process.env.VUE_APP_COMMENT_IMAGE_URL // 图片路径
    };
  },
  watch: {
    memberData: {
      handler: function handler(newVal) {
        if (newVal) {
          // 处理生日时间戳转换
          var birthdayValue = '';
          if (newVal.birthday) {
            // 如果是时间戳，转换为日期字符串
            var date = new Date(newVal.birthday);
            birthdayValue = date;
          }

          // 只保留表单需要的字段，避免不必要的字段污染
          var filteredData = {
            userId: newVal.userId || newVal.id,
            // 优先使用userId，如果没有则使用id
            userName: newVal.userName || '',
            email: newVal.email || '',
            alias: newVal.alias || '',
            mobilePhone: newVal.mobilePhone || newVal.mobile || '',
            // 支持mobilePhone和mobile字段
            userpic: newVal.userpic || '',
            // 兼容userpic字段
            userRank: newVal.userRank || null,
            // 修改为 null
            sex: newVal.sex !== undefined ? newVal.sex : 0,
            registerType: newVal.registerType || 0,
            // 注册方式
            isTest: newVal.isTest || false,
            isLogin: newVal.isLogin !== undefined ? newVal.isLogin : true,
            // 是否允许登录
            birthday: birthdayValue
          };
          this.formData = _objectSpread(_objectSpread({}, this.formData), filteredData);
        } else {
          this.resetForm();
        }
      },
      immediate: true
    }
  },
  computed: {
    // 处理头像显示URL，拼接图片前缀
    displayAvatarUrl: function displayAvatarUrl() {
      if (!this.formData.userpic) {
        return '';
      }

      // 如果已经是完整URL（以http或https开头），则直接返回
      if (this.formData.userpic.startsWith('http://') || this.formData.userpic.startsWith('https://')) {
        return this.formData.userpic;
      }

      // 如果是blob URL（本地预览），则直接返回
      if (this.formData.userpic.startsWith('blob:')) {
        return this.formData.userpic;
      }

      // 其他情况拼接图片前缀
      return this.imagePrefix ? this.imagePrefix + this.formData.userpic : this.formData.userpic;
    }
  },
  mounted: function mounted() {
    // 组件挂载后获取等级列表和图片前缀
    this.getVipGradeList();
  },
  beforeDestroy: function beforeDestroy() {
    // 清理头像预览URL
    this.revokeAvatarUrl();
  },
  methods: {
    // 获取会员等级列表
    getVipGradeList: function () {
      var _getVipGradeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.gradeLoading = true;
              _context.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100 // 获取所有等级，如果等级很多可以分页
              });
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.records) {
                this.vipGrades = response.records.map(function (grade) {
                  return {
                    id: grade.id,
                    name: grade.name,
                    levelId: grade.levelId
                  };
                });
                console.log('获取等级列表成功：', this.vipGrades);
              } else {
                this.$message.error('获取等级列表失败');
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取等级列表错误：', _t);
              this.$message.error('获取等级列表失败');
            case 3:
              _context.prev = 3;
              this.gradeLoading = false;
              return _context.finish(3);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2, 3, 4]]);
      }));
      function getVipGradeList() {
        return _getVipGradeList.apply(this, arguments);
      }
      return getVipGradeList;
    }(),
    // 重置表单
    resetForm: function resetForm() {
      this.formData = {
        // userId: null,
        userName: '',
        email: '',
        alias: '',
        mobilePhone: '',
        // 添加手机号字段
        userpic: '',
        userRank: null,
        // 修改为 null
        sex: 0,
        registerType: 0,
        isTest: false,
        isLogin: true,
        birthday: ''
      };
      this.revokeAvatarUrl();
    },
    // 头像上传前验证
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    // 头像上传处理
    handleAvatarChange: function () {
      var _handleAvatarChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(file) {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              console.log('头像上传文件：', file);

              // 先验证文件
              if (this.beforeAvatarUpload(file.raw)) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              this.revokeAvatarUrl(); // 先清理旧的URL
              _context2.prev = 2;
              this.avatarUploading = true;

              // 调用上传接口
              _context2.next = 3;
              return (0, _memberManagement.uploadAvatar)(file.raw);
            case 3:
              response = _context2.sent;
              console.log('头像上传响应：', response);
              if (response.code === 200) {
                // 上传成功，使用返回的data字段作为图片URL
                this.formData.userpic = response.data;
                this.$message.success('头像上传成功');
                console.log('头像上传成功，图片URL：', this.formData.userpic);
              } else {
                this.$message.error(response.message || '头像上传失败');
                // 上传失败时使用本地预览
                if (file.raw) {
                  this.avatarPreviewUrl = URL.createObjectURL(file.raw);
                  this.formData.userpic = this.avatarPreviewUrl;
                }
              }
              _context2.next = 5;
              break;
            case 4:
              _context2.prev = 4;
              _t2 = _context2["catch"](2);
              console.error('头像上传错误：', _t2);
              this.$message.error('头像上传失败：' + (_t2.message || '网络错误'));

              // 上传失败时使用本地预览
              if (file.raw) {
                this.avatarPreviewUrl = URL.createObjectURL(file.raw);
                this.formData.userpic = this.avatarPreviewUrl;
              }
            case 5:
              _context2.prev = 5;
              this.avatarUploading = false;
              return _context2.finish(5);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 4, 5, 6]]);
      }));
      function handleAvatarChange(_x) {
        return _handleAvatarChange.apply(this, arguments);
      }
      return handleAvatarChange;
    }(),
    // 清理头像预览URL
    revokeAvatarUrl: function revokeAvatarUrl() {
      if (this.avatarPreviewUrl) {
        URL.revokeObjectURL(this.avatarPreviewUrl);
        this.avatarPreviewUrl = null;
      }
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this = this;
      console.log('MemberForm handleSubmit被调用');
      console.log('表单数据：', this.formData);
      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          // 准备提交的数据
          var submitData = _objectSpread({}, _this.formData);
          // 处理生日字段，如果有日期值，转换为时间戳
          if (submitData.birthday) {
            submitData.birthday = new Date(submitData.birthday);
          }
          _this.$emit('submit', submitData);
        } else {
          console.log('表单验证失败');
          _this.$message.error('请检查表单信息');
        }
      });
    },
    // 取消操作
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};